import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import Cookies from "@/lib/cookies";
import { createHash, randomBytes } from "crypto";

var PINCode = /*#__PURE__*/function () {
  function PINCode(req, res) {
    var _config$pincode$redis, _config$pincode$redis2, _config$pincode$redis3, _config$pincode, _config$pincode$redis4;

    _classCallCheck(this, PINCode);

    this.req = req;
    this.res = res;
    this.cookies = new Cookies(req, res);
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$pincode$redis = config.pincode.redis) === null || _config$pincode$redis === void 0 ? void 0 : _config$pincode$redis.host),
      port: process.env.REDIS_PORT || ((_config$pincode$redis2 = config.pincode.redis) === null || _config$pincode$redis2 === void 0 ? void 0 : _config$pincode$redis2.port),
      keyPrefix: config.pincode.redis.prefix,
      db: (_config$pincode$redis3 = config.pincode.redis) === null || _config$pincode$redis3 === void 0 ? void 0 : _config$pincode$redis3.db
    }, (_config$pincode = config.pincode) === null || _config$pincode === void 0 ? void 0 : (_config$pincode$redis4 = _config$pincode.redis) === null || _config$pincode$redis4 === void 0 ? void 0 : _config$pincode$redis4.cluster);
  }

  _createClass(PINCode, [{
    key: "generatePINCode",
    value: function generatePINCode() {
      var randomNum = function randomNum() {
        return Math.floor(Math.random() * 10);
      };

      return Array.from(Array(4)).map(randomNum).join("");
    }
  }, {
    key: "generateToken",
    value: function generateToken() {
      return randomBytes(32).toString("hex");
    }
  }, {
    key: "generateHash",
    value: function generateHash(key) {
      return createHash("sha256").update(key).digest("hex");
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.cookies.get(config.pincode.name);
    }
  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
        var pin, token, hash;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pin = this.generatePINCode();
                token = this.generateToken();
                hash = this.generateHash(key);
                _context.next = 5;
                return this.redis.multi().set(hash, JSON.stringify({
                  pin: pin,
                  token: token
                })).expire(hash, config.pincode.maxAge).exec();

              case 5:
                this.cookies.set([{
                  name: config.pincode.name,
                  value: token,
                  option: {
                    maxAge: config.pincode.maxAge
                  }
                }]);
                return _context.abrupt("return", pin);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function publish(_x) {
        return _publish.apply(this, arguments);
      }

      return publish;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value, key) {
        var token, hash, json, payload;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                token = this.getToken();

                if (token) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                hash = this.generateHash(key);
                _context2.next = 6;
                return this.redis.get(hash);

              case 6:
                json = _context2.sent;

                if (json) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", false);

              case 9:
                payload = JSON.parse(json);
                return _context2.abrupt("return", (payload === null || payload === void 0 ? void 0 : payload.pin) === value && (payload === null || payload === void 0 ? void 0 : payload.token) === token);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function verify(_x2, _x3) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var hash, token;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                hash = this.generateHash(key);
                _context3.next = 3;
                return this.redis.del(hash);

              case 3:
                token = this.getToken();

                if (token) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", false);

              case 6:
                this.cookies.remove([config.pincode.name]);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _delete(_x4) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return PINCode;
}();

export { PINCode as default };